import React, { Component } from 'react';

import { Link } from "react-router-dom";
import './../scss/ShowCard.scss';

import Premium from '../svg/Premium/Premium';
import PropTypes from 'prop-types';
import Sizer from './util/Sizer';
import { shapeFixer, RATIO_16x9 } from '../../util/imageUtils';
import NewEpisode from './ui/NewEpisode';

// import {getRelativeUrl, randomImg} from './../../util/lib.js';

class ShowCard extends Component {

	render() {
		const props = this.props,
			card = props.card,
			float = props.float ? props.float : '',
			size = props.size ? props.size : 'col-12 col-sm-6 col-md-4 col-lg-3',
			data = card.data,
			meta = card.meta,
			showThumbnails = data.show_thumbnail || {},
			showThumbnails16x9 = showThumbnails[RATIO_16x9] || {},
			thumb = (props.mobileWidth ? showThumbnails16x9["150"] : showThumbnails16x9["320"]) || showThumbnails16x9["320"],

			showDurationYN = card.meta.showDurationYN || false,
			showViewsYN = card.meta.showViewsYN || false,

			show_name = data.show_name,
			videoCount = data.video_count_formatted || data.videos_count || '',
			show_duration = data.show_duration_formatted_short,
			show_movie_name = data.show_movie_name || '',
			show_views = data.show_views,
			show_url = data.show_url.path,

			canShowTitleYN = meta.canShowTitleYN,
			showVideoCountYN = meta.showVideoCountYN, 
			show_video_details = true,
			labels = data.labels || {};

		return (
			<div className={"v-card show-card card " + size + " " + float} title={show_name}>
					<Link to={show_url}>
						<img src={shapeFixer(RATIO_16x9)}  alt={show_name}/>
						<img className="card-img-top primary-thumb" src={thumb} alt={show_name}/>
					   
						{meta.isPremiumYN && 
							<div className="show-premium-icon">
								<Premium />
								{/* <img src={premium} className="img-fluid" alt="premium"/> */}
							</div>
						}
						{canShowTitleYN && videoCount &&
							<span className='show-inline-name'>
								{videoCount}
							</span>
						}
						{meta.isNewEpisodeYN && <NewEpisode label={labels.new_episode_label || 'New Episodes'}/>}
					</Link>

					{show_video_details &&
						<div className="card-body">
							<div className='card-primary-text'>
								
								{canShowTitleYN && <div className="show-name">
									<Link to={show_url}>{show_name}</Link>
								</div>}
								{showVideoCountYN && <div className="video-count">
									<Link to={show_url}>{videoCount}</Link>
								</div>}
								<div className='show-duration text-right'>{showDurationYN && show_duration}</div>

							</div>
							<div className='card-secondary-text d-flex flex-row justify-content-between'>
								<div className='show-movie-name'>{show_movie_name}</div>
								<div className='show-views text-right'>{showViewsYN && show_views + ' VIEWS'}</div>
							</div>
						</div>
					}
			</div>
		);
	}
}

ShowCard.propTypes = {
	float: PropTypes.string,
	size : PropTypes.string,
   hideVideoDetials: PropTypes.bool,
	card: PropTypes.shape({
		type: PropTypes.string,
		data: PropTypes.shape({
			video_description: PropTypes.string,
			video_duration: PropTypes.number,
			video_duration_formatted: PropTypes.string,
			video_duration_formatted_short: PropTypes.string,
			video_language: PropTypes.string,
			show_name: PropTypes.string,
			video_show_name: PropTypes.string,
			show_thumbnail: PropTypes.object,
			show_url: PropTypes.shape({
				path: PropTypes.string,
				url: PropTypes.string,
			}),
			video_views: PropTypes.string,
		}),
		meta: PropTypes.array,
	})
}
export default Sizer(ShowCard);